export type CurationProxyBase = "api" | "imageUpload" | "imageService";

/**
 * Options for calling the Curation Proxy
 * @param path - Path to the API endpoint
 * @param method - HTTP method (GET, POST, PUT, DELETE)
 * @param body - Request body
 * @param headers - Request headers
 * @param base - Base URL for the API (api, imageUpload, or imageService)
 */
export interface CurationProxyOptions {
    path: string;
    method?: string;
    body?: unknown;
    headers?: Record<string, string>;
    base?: CurationProxyBase;
}

/**
 * Calls the Curation Proxy
 * @param path
 * @param method
 * @param body
 * @param headers
 * @param base
 */
export const callCurationProxy = ({
    path,
    method = "GET",
    body,
    headers,
    base = "api",
}: CurationProxyOptions): Promise<Response> => {
    if (!path?.trim()) {
        throw new Error("callCurationProxy requires a valid path.");
    }

    const payload: Record<string, unknown> = {
        path,
        method,
        base,
    };

    if (headers) {
        const headerCount = Object.keys(headers).length;
        if (headerCount > 0) {
            payload.headers = headers;
        }
    }

    if (body !== undefined) {
        payload.body = body;
    }

    return fetch("/api/Curation/proxy", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
        credentials: "include",
    });
};
